<template>
  <div>
    <SustainabilityHero2025 :images="heroImages" />
    <div
      id="sustainability-report-content-start"
      class="sustainability-report-2025__content-start"
      aria-hidden="true"
    />
    <HeadlessLayout :sections="content" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";
import SustainabilityReportContent from "@/content/SustainabilityReport2025.json";
import SustainabilityHero2025 from "@/components/sustainability2025/SustainabilityHero2025.vue";

export default {
  name: "SustainabilityReport2025",
  components: {
    HeadlessLayout,
    SustainabilityHero2025,
  },
  data() {
    return {
      content: SustainabilityReportContent,
      heroImages: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_1.jpg?v=1776678578",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_1.jpg?v=1776678578",
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_2695_1_34c7294f-0bc4-4083-b27c-55a062cb2d23.jpg?v=1776678356",
      },
    };
  },
  created() {
    const app = document.querySelector("#app");
    app.classList.remove("fixed-header");
  },
  mounted() {
    const url = new URL(window.location);
    const sectionSlug = url.searchParams.get("section") || "introduction";

    const matchedSection = this.content.find(
      (section) => section.slug === sectionSlug
    );

    if (matchedSection) {
      this.updateSelectedSection({
        section: matchedSection.slug,
        navigate: false,
      });
    }
  },
  methods: {
    ...mapActions("sustainability", ["updateSelectedSection"]),
  },
};
</script>

<style lang="scss" scoped>
.sustainability-report-2025__content-start {
  height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  pointer-events: none;
  /* Nudge land ~200px “higher” so more hero stays in view; pairs with nudge in scroll.js fallbacks. */
  scroll-margin-top: 200px;
}
</style>
